export var CLASS_NAME_SHOW = 'show';
export var CLASS_NAME_FADE = 'fade';


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/constants/classes.js
// module id = null
// module chunks = 